import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'mh-collect-theme',
    templateUrl: './collect-theme.component.html',
    standalone: false
})
export class CollectThemeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
